module.exports = __webpack_public_path__ + "img/hdbm.dd788a66.png";